import { lazy, Suspense } from 'react';
import { Modal, View } from 'react-native';
import type { Course, LeadData } from '@/types/chat';

const LeadModal = lazy(() => import('./LeadModal').then(mod => ({ default: mod.LeadModal })));

interface Props {
  visible: boolean;
  course: Course | null;
  onClose: () => void;
  onSubmit: (leadData: LeadData) => Promise<void>;
}

export function LazyLeadModal(props: Props) {
  if (!props.visible) return null;

  return (
    <Suspense fallback={
      <Modal visible={props.visible} transparent animationType="fade">
        <View style={{ flex: 1, backgroundColor: 'rgba(0, 0, 0, 0.5)' }} />
      </Modal>
    }>
      <LeadModal {...props} />
    </Suspense>
  );
}
